module.exports = __webpack_public_path__ + "img/bitcoin.418c9e2e.jpg";